/**
 * Submittal Review Checklist Templates — service layer (Submittal Review Tool Phase 2). Backed
 * by api/submittal-checklists.js (Supabase `submittal_checklist_templates` +
 * `submittal_checklist_template_items`). Editable in TemplatesWorkspace — never static config,
 * no deploy required. Authoring/template side only — nothing consumes these yet (Phase 5).
 */

async function authHeaders() {
  const token = await window.__clerkGetToken()
  return { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token }
}

async function call(method, body) {
  const res = await fetch('/api/submittal-checklists', {
    method,
    headers: await authHeaders(),
    body: body ? JSON.stringify(body) : undefined,
  })
  const data = await res.json().catch(() => ({}))
  if (!res.ok) throw new Error(data.error || ('Submittal checklist request failed (' + res.status + ')'))
  return data
}

/** All submittal checklist templates with their ordered items. */
export function getSubmittalChecklistTemplates() {
  return call('GET').then(d => d.templates)
}

export function createSubmittalChecklistTemplate(name, sectionPrefixes) {
  return call('POST', { action: 'createTemplate', name, sectionPrefixes }).then(d => d.template)
}
export function renameSubmittalChecklistTemplate(id, name, sectionPrefixes) {
  const body = { action: 'renameTemplate', id }
  if (name !== undefined) body.name = name
  if (sectionPrefixes !== undefined) body.sectionPrefixes = sectionPrefixes
  return call('POST', body).then(d => d.template)
}
export function deleteSubmittalChecklistTemplate(id) {
  return call('POST', { action: 'deleteTemplate', id })
}
export function moveSubmittalChecklistTemplate(id, direction) {
  return call('POST', { action: 'moveTemplate', id, direction })
}

export function createSubmittalChecklistItem(templateId, text) {
  return call('POST', { action: 'createItem', templateId, text }).then(d => d.item)
}
export function updateSubmittalChecklistItem(id, text) {
  return call('POST', { action: 'updateItem', id, text }).then(d => d.item)
}
export function deleteSubmittalChecklistItem(id) {
  return call('POST', { action: 'deleteItem', id })
}
export function moveSubmittalChecklistItem(id, direction) {
  return call('POST', { action: 'moveItem', id, direction })
}
